import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { logout as logoutAction } from '../../auth/store/actions'
import { MenuItemContainer } from '../../mainMenu'

const LogoutMenuItem = () => {
  const dispatch = useDispatch()
  const handleClick = useCallback((event) => {
    event.preventDefault()
    dispatch(logoutAction())
  }, [dispatch])

  return (
    <MenuItemContainer onClick={handleClick} title='Logout' className='nav-logout' htmlTag='button'>
      Logout
    </MenuItemContainer>
  )
}

export default LogoutMenuItem
